import { STAFF_ROLES } from "@shared/core/types";
import type { WebModule } from "../../core/modules";
import { ImportsPage } from "./routes/imports";
import { ReviewPage } from "./routes/review";

const xExtraction: WebModule = {
  name: "x-extraction",
  routes: [
    { path: "/importations", element: <ImportsPage />, roles: STAFF_ROLES },
    { path: "/importations/:id", element: <ReviewPage />, roles: STAFF_ROLES },
  ],
  nav: [
    {
      title: "Recrutement",
      order: 11,
      roles: STAFF_ROLES,
      items: [{ to: "/importations", label: "Importer des CV", icon: "sparkles", end: false }],
    },
  ],
};

export default xExtraction;
